<template>
  <v-dialog v-model="modalIsOpen" width="400px" height="500px">
    <v-card class="panel pa-6">
      <div
        :class="{ 'text-h4': !isMobileSized }"
        :style="{ 'font-size': isMobileSized ? '1.5rem' : '' }"
      >
        Resume Progress?
      </div>
      <div><p>Would you like to pick up from where you left off last time?</p></div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :small="isMobileSized"
          class="white--text"
          color="blue darken-2"
          @click="resumeProgress('resume')"
          >Resume Progress</v-btn
        >
        <v-btn
          :small="isMobileSized"
          dark
          class="ml-4"
          color="grey lighten-1"
          @click="resumeProgress('cancel')"
          >No Thanks</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResumeProgress',
  props: {
    modalIsOpen: {
      type: Boolean,
      required: true,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resumeProgress(resume) {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-resume_progress_modal_${resume}_button-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.$emit('resumeProgress', resume)
    },
  },
}
</script>
